export default {
  GET_ALL: `#graphql
  query getGiftVouchers($search: String, $searchBy: String, $search1: String, $searchBy1: String, $limit: Int, $page: Int, $sort: String, $order: String, $init: Date, $final: Date) {
    getGiftVouchers(search: $search, searchBy: $searchBy, search1: $search1, searchBy1: $searchBy1, limit: $limit, page: $page, sort: $sort, order: $order, init:  $init, final: $final)
    { 
      docs {
        phone,
        name,
        createdAt,
        email,
        value,
        status,
        _id,
        methodPay
      },
      totalDocs,
      limit,
      hasPrevPage,
      hasNextPage,
      page,
      totalPages,
      prevPage,
      nextPage,
      pagingCounter
    }            
  }`,

  UPDATE: `#graphql
  mutation UpdateGiftVoucher($phone: String!, $giftVoucherUpdate: GiftVoucherUpdateInput!) {
    updateGiftVoucher(phone:$phone, giftVoucherUpdate: $giftVoucherUpdate)
    {
      phone
    }            
  }`,

  DELETE: `#graphql
  mutation DeleteGiftVoucher($phone: String!) {
    deleteGiftVoucher(phone:$phone)
    {
      phone
    }            
  }`,

  APPROVE: `#graphql
  mutation approveGiftVoucher($phone: String!) {
    approveGiftVoucher(phone:$phone)           
  }`,

  DISAPPROVE: `#graphql
  mutation disapproveGiftVoucher($phone: String!) {
    disapproveGiftVoucher(phone:$phone)           
  }`,

  PAY: `#graphql
  mutation payGiftVoucher($phone: String!) {
    payGiftVoucher(phone:$phone)           
  }`,

  UNPAY: `#graphql
  mutation unpayGiftVoucher($phone: String!) {
    unpayGiftVoucher(phone:$phone)           
  }`,

  REDEEMED: `#graphql
  mutation redeemedGiftVoucher($phone: String!) {
    redeemedGiftVoucher(phone:$phone)           
  }`,

  UNREDEEMED: `#graphql
  mutation unredeemedGiftVoucher($phone: String!) {
    unredeemedGiftVoucher(phone:$phone)           
  }`,

  UPDATE_METHOD_PAY: `#graphql
  mutation updateMethodPayGiftVoucher($phone: String!, $methodPay: String!) {
    updateMethodPayGiftVoucher(phone:$phone, methodPay: $methodPay)           
  }`
}



// WEBPACK FOOTER //
// ./src/graphql/giftVoucher.js